import { useState } from 'react';
import { IconApps, IconWallet, IconReceipt, IconCreditCard, IconSettings } from '@tabler/icons-react';
import ComingSoonModal from './ComingSoonModal';

export default function BottomNav() {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const handleButtonClick = (modalName: string) => {
    setActiveModal(modalName);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const modalConfigs = {
    apps: {
      title: 'Apps',
      description: 'The Apps section is coming soon. We\'re working on bringing you a curated collection of decentralized applications.',
      icon: <IconApps size={36} className="text-primary" />
    },
    wallet: {
      title: 'Wallet',
      description: 'The Wallet section is coming soon. We\'re working on bringing you a secure and easy-to-use wallet interface.',
      icon: <IconWallet size={36} className="text-primary" />
    },
    transactions: {
      title: 'Transactions',
      description: 'The Transactions section is coming soon. We\'re working on bringing you a comprehensive transaction history view.',
      icon: <IconReceipt size={36} className="text-primary" />
    },
    subscriptions: {
      title: 'Subscriptions',
      description: 'The Subscriptions section is coming soon. We\'re working on bringing you a way to manage your recurring payments.',
      icon: <IconCreditCard size={36} className="text-primary" />
    },
    settings: {
      title: 'Settings',
      description: 'The Settings section is coming soon. We\'re working on bringing you a way to customize your experience.',
      icon: <IconSettings size={36} className="text-primary" />
    }
  };

  return (
    <>
      <nav className="mt-auto border-t border-surface/50 safe-bottom">
        <div className="flex justify-around py-3 px-2">
          <button 
            type="button" 
            className="flex flex-col items-center gap-1 min-w-[64px]"
            onClick={() => handleButtonClick('apps')}
          >
            <IconApps size={22} className="text-white" />
            <span className="text-[11px] text-white">Apps</span>
          </button>
          <button 
            type="button" 
            className="flex flex-col items-center gap-1 min-w-[64px]"
            onClick={() => handleButtonClick('wallet')}
          >
            <IconWallet size={22} className="text-text-secondary" />
            <span className="text-[11px] text-text-secondary">Wallet</span>
          </button>
          <button 
            type="button" 
            className="flex flex-col items-center gap-1 min-w-[64px]"
            onClick={() => handleButtonClick('transactions')}
          >
            <IconReceipt size={22} className="text-text-secondary" />
            <span className="text-[11px] text-text-secondary">Transactions</span>
          </button>
          <button 
            type="button" 
            className="flex flex-col items-center gap-1 min-w-[64px]"
            onClick={() => handleButtonClick('subscriptions')}
          >
            <IconCreditCard size={22} className="text-text-secondary" />
            <span className="text-[11px] text-text-secondary">Subscriptions</span>
          </button>
          <button 
            type="button" 
            className="flex flex-col items-center gap-1 min-w-[64px]"
            onClick={() => handleButtonClick('settings')}
          >
            <IconSettings size={22} className="text-text-secondary" />
            <span className="text-[11px] text-text-secondary">Settings</span>
          </button>
        </div>
      </nav>

      {activeModal && (
        <ComingSoonModal
          isOpen={true}
          onClose={handleCloseModal}
          title={modalConfigs[activeModal as keyof typeof modalConfigs].title}
          description={modalConfigs[activeModal as keyof typeof modalConfigs].description}
          icon={modalConfigs[activeModal as keyof typeof modalConfigs].icon}
        />
      )}
    </>
  );
} 